import React from 'react';
import './Sell.css';

export const Sell: React.FC<{}> = () => {
  return <p className="sell">Nothing here</p>;
};
